import * as React from 'react';
import { IAthlete, IGroup, ITeam } from '../../../../data/types';
import { Row } from '../../../layout/Row';
import { EntityFilter } from '../../../shared/filters/EntityFilter';
import { SearchInput } from '../../../shared/form/SearchInput';
import { Controls, ControlsLeftSide, ControlsRightSide } from '../Controls';
import { AddAthletesPopup } from './AddAthletesPopup';

interface IProps {
  onSearch: (search: string) => void;
  search: string;
  groups: IGroup[];
  teams: ITeam[];
  groupsLoading: boolean;
  teamsLoading: boolean;
  filteredGroups: string[];
  setFilteredGroups: (f: string[]) => void;
  filteredTeams: string[];
  setFilteredTeams: (f: string[]) => void;
  loading: boolean;
  athletes: IAthlete[];
}

export const AthleteControls = (props: IProps): React.ReactElement => {
  const clearSearch = (): void => props.onSearch('');

  return !props.loading ? (
    <Controls>
      <ControlsLeftSide>
        <Row>
          <SearchInput
            value={props.search}
            onClear={clearSearch}
            onChange={props.onSearch}
            style={{ margin: '0px' }}
          />
        </Row>
      </ControlsLeftSide>
      <ControlsRightSide style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <AddAthletesPopup />
        <EntityFilter
          level={0}
          teams={props.teams}
          groups={props.groups}
          teamsLoading={props.teamsLoading}
          groupsLoading={props.groupsLoading}
          filteredTeams={props.filteredTeams}
          filteredGroups={props.filteredGroups}
          applyTeamFilter={props.setFilteredTeams}
          applyGroupFilter={props.setFilteredGroups}
        />
      </ControlsRightSide>
    </Controls>
  ) : null;
};
